module.exports = __webpack_public_path__ + "static/img/fachada_parking.4a38d216.jpg";